import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { Table } from '../../..'
import { store as storeProps } from '../../../../types'
import storeTableDisplay from './EstateList.table'
import EstateListTitle from './EstateListTitle'
import { usePageTitle } from '../../../../actions/app'
import { getSelectedEstate } from '../../../../reducers/app'
import { useAppSelector } from '../../../../reducers'

const EstateList = ({
    children,
    clearFilters,
    isFilterActive,
    isLoading,
    mode,
    nextPage,
    onChangeSearch,
    onChangeSort,
    onClickStore,
    onKeyPress,
    openCloseFilters,
    sortable,
    stores,
    t,
    totalDevices,
    totalFilteredDevices,
    valueSearch,
}) => {
    const estate = useAppSelector(getSelectedEstate)
    usePageTitle(estate?.name)

    return (
        <Table
            data={stores}
            display={storeTableDisplay({
                search: mode === 'searchByDevice' ? valueSearch : '',
                t,
            })}
            fieldsNotToSort={[]}
            isLoading={isLoading}
            keyField="code"
            nextPage={nextPage}
            onChangeSort={onChangeSort}
            onClickRow={onClickStore}
            sortable
            sortableByAPI={sortable}
        >
            {
                <EstateListTitle
                    clearFilters={clearFilters}
                    isFilterActive={isFilterActive}
                    totalData={totalDevices}
                    totalFilteredData={totalFilteredDevices}
                    openCloseFilters={openCloseFilters}
                    onChangeSearch={onChangeSearch}
                    onKeyPress={onKeyPress}
                    valueSearch={valueSearch}
                >
                    {children}
                </EstateListTitle>
            }
        </Table>
    )
}

EstateList.propTypes = {
    addButton: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
    children: PropTypes.node,
    clearFilters: PropTypes.func,
    isFilterActive: PropTypes.bool,
    isLoading: PropTypes.bool,
    mode: PropTypes.string,
    nextPage: PropTypes.func,
    onChangeSearch: PropTypes.func,
    onChangeSort: PropTypes.func,
    onClickStore: PropTypes.func,
    onKeyPress: PropTypes.func,
    openCloseFilters: PropTypes.func,
    sortable: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.arrayOf(
            PropTypes.shape({
                fieldToSort: PropTypes.string,
                sortType: PropTypes.string,
            })
        ),
    ]),
    stores: PropTypes.arrayOf(PropTypes.shape(storeProps)),
    t: PropTypes.func.isRequired,
    totalDevices: PropTypes.number,
    totalFilteredDevices: PropTypes.number.isRequired,
    valueSearch: PropTypes.string,
}

EstateList.defaultProps = {
    addButton: null,
    children: null,
    clearFilters: () => null,
    isFilterActive: false,
    isLoading: false,
    mode: '',
    nextPage: null,
    onChangeSearch: () => null,
    onChangeSort: () => null,
    onClickStore: () => null,
    onKeyPress: () => null,
    openCloseFilters: () => null,
    sortable: true,
    stores: [],
    valueSearch: '',
}

export default withTranslation()(EstateList)
